import React from "react";
import { Link, useParams } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Badge,
  ListGroup,
  ListGroupItem
} from "reactstrap";
import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";
import IntlMessages from "Util/IntlMessages";
import { useAsyncResource } from "../../../../../hooks/useAsyncResource";
import { suiteApi } from "../../../../../api/suiteAdapters";
import { AsyncStateBoundary } from "../../_suite/primitives";

export default function CustomerOrgDetailPage() {
  const { id } = useParams();
  const { data, loading, error } = useAsyncResource(
    () => (id ? suiteApi.ticketing.getCustomer(id) : Promise.resolve(null)),
    [id]
  );

  return (
    <div>
      <Row>
        <Colxx xxs="12">
          <BreadcrumbContainer
            heading={<IntlMessages id="suite.ticketing.customer-detail" />}
          />
          <Separator className="mb-4" />
        </Colxx>
      </Row>
      <Button tag={Link} color="light" to=".." relative="path" className="mb-3">
        ← <IntlMessages id="suite.action.back" />
      </Button>

      <AsyncStateBoundary
        loading={loading}
        error={error}
        empty={!loading && !data}
        emptyMessageId="suite.state.notfound"
      >
        {data && (
          <Row>
            <Col md="8" className="mb-4">
              <Card className="border-0 shadow-sm mb-4">
                <CardBody>
                  <div className="d-flex align-items-start justify-content-between">
                    <div>
                      <h3 className="mb-1">{data.name}</h3>
                      <p className="text-muted mb-0">{data.id}</p>
                    </div>
                    <Badge color="primary" className="fs-6">
                      {data.tier}
                    </Badge>
                  </div>
                </CardBody>
              </Card>
              <Card className="border-0 shadow-sm">
                <CardBody>
                  <CardTitle tag="h5">Open tickets (demo)</CardTitle>
                  <p className="text-muted small">
                    Replace with tickets filtered by organization from your API.
                  </p>
                  <Button
                    tag={Link}
                    color="outline-primary"
                    size="sm"
                    to="../../tickets"
                    relative="path"
                  >
                    Go to queue
                  </Button>
                </CardBody>
              </Card>
            </Col>
            <Col md="4">
              <Card className="border-0 shadow-sm bg-light">
                <CardBody>
                  <CardTitle tag="h6">Account snapshot</CardTitle>
                  <ListGroup flush>
                    <ListGroupItem className="bg-transparent px-0 border-0 d-flex justify-content-between">
                      <span className="text-muted">Contacts</span>
                      <strong>{data.contacts}</strong>
                    </ListGroupItem>
                    <ListGroupItem className="bg-transparent px-0 border-0 d-flex justify-content-between">
                      <span className="text-muted">Region</span>
                      <strong>{data.region}</strong>
                    </ListGroupItem>
                  </ListGroup>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </AsyncStateBoundary>
    </div>
  );
}
